import { Area } from "../../../types";

export const centerContentInContainer = (
  contentArea: Area,
  containerArea: Area,
  axis: "x" | "y",
): Area => {
  const newContentArea = { ...contentArea };

  if (axis === "x") {
    // Center horizontally: position image so it's centered in the clear area
    newContentArea.x =
      containerArea.x + (containerArea.width - newContentArea.width) / 2;
  } else {
    // Center vertically: position image so it's centered in the clear area
    newContentArea.y =
      containerArea.y + (containerArea.height - newContentArea.height) / 2;
  }

  return newContentArea;
};
